import Swiper from 'swiper/swiper-bundle.js'
import lightGallery from "lightgallery";
import $ from 'jquery'

const $village_maps = $(".village-maps-list__item")
const $maui_rainfall = $('.maui-rainfall-image')
const $curved_swiper = $('.image-wrapper-curved')

const create_lightbox = (container, swiper_slide) => {
    const swiperContainers = document.querySelector('.' + container);
    const gsBgImgSelector = '.' + swiper_slide + " img";

    const dynamicEl = [...swiperContainers.querySelectorAll(gsBgImgSelector)].map(
        (sliderImg) => {
            return {
                src: sliderImg.src,
                thumb: sliderImg.src,
                subHtml: sliderImg.alt,
            };
        }
    );
    const dynamicGallery = swiperContainers
    const popup = lightGallery(dynamicGallery, {
        dynamic: true,
        loop: true,
        autoplayVideoOnSlide: true,
        dynamicEl,
    });
    dynamicGallery.addEventListener('click', () => {
        popup.openGallery(0);
    });
    [...swiperContainers.querySelectorAll('.swiper-slide')].map((slide, idx) => {
        slide.addEventListener('click', () => {
            popup.openGallery(idx);
        });
    });
}

const home_swiper = new Swiper(".leftSwiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const home_swiper2 = new Swiper(".rightSwiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const curved_swiper = new Swiper(".swiper-curved", {
    loop: true,
    slidesPerView: 2.3,
    spaceBetween: 10,
    centeredSlides: true,
    slideToClickedSlide: true,
    freeMode: true,
    navigation: {
        nextEl: ".curved-swiper .swiper-button-next",
        prevEl: ".curved-swiper .swiper-button-prev",
    },
    breakpoints: {
        950: {
            slidesPerView: 2.3
        },
        481: {
            slidesPerView: 1.5
        },
        100: {
            slidesPerView: 1,
        }
    }
});

if ($curved_swiper.length) {
    create_lightbox("image-wrapper-curved", "curved-slide")
}

const footer_swiper = new Swiper(".footerSwiper", {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    fadeEffect: {
        crossFade: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
});

$(window).on('load resize', () => {
    const $testimonials = $('.footerSwiper .swiper-slide')
    $testimonials.css('height', '')
    const heights = $testimonials.map((i, el) => $(el).height())
    const maxHeight = Math.max.apply(null, heights)
    $testimonials.css('height', maxHeight)
})

const property_swiper = new Swiper(".property-Swiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const property_swiper2 = new Swiper("right.property-Swiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const about_swiper = new Swiper(".about-us-swiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
});

if($(".lg-prev").length) {
    $(".lg-prev, .lg-next").on('click', function() {
        if($(this).hasClass('lg-next')) {
            $('.swiper-button-next').click()
        } else if($(this).hasClass('lg-prev')) {
            $('.swiper-button-prev').click()
        }
    })
}

if ($maui_rainfall.length) {
    create_lightbox("maui-rainfall-image", "wp-block-image")
}

for (let i = 0; i < $village_maps.length; i++) {
    create_lightbox("village-map" + i, "village-maps-list__item")
}

